module.exports = "<app-operating-standard></app-operating-standard>"


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/home-tasks/home-tasks.component.html
// module id = ../../../../../src/app/content-page/home-tasks/home-tasks.component.html
// module chunks = main